import { Component, HostListener, input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  template: '',
})
export abstract class BaseSmartInputComponent<T> {
  readonly control = input.required<FormControl<T | null | undefined>>();
  readonly placeholder = input('');
  readonly resetValue = input<T | undefined>(undefined);

  @HostListener('keydown.escape')
  async onEscape(): Promise<void> {
    void this.onCancel();
  }

  onInput() {
    this.control().markAsTouched({ onlySelf: true });
    this.control().updateValueAndValidity({ emitEvent: false });
  }

  onCancel() {
    const resetValue = this.resetValue();
    if (resetValue) {
      this.control().patchValue(resetValue);
      this.control().markAsPristine();
    }
  }
}
